import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
    selector: 'lh-modal-help',
    templateUrl: './modal-help.component.html',
    styleUrls: ['./modal-help.component.scss'],
    standalone: false
})
export class ModalHelpComponent implements OnInit {

  constructor(public modalCtrl: ModalController) { }

  ngOnInit() { }

  closeModal() {
    this.modalCtrl.dismiss();
  }

}
